import { http } from 'src/interfaces/http'

export const downloadBlob = async (url: string): Promise<Blob> => {
  const { data } = await http.get<Blob>(url, {
    responseType: 'blob',
    // Document transfers are intentionally allowed far longer than interactive
    // page-data requests, which use the shared ten-second deadline.
    timeout: 120_000,
  })
  return data
}
